"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _gatsby = require("gatsby");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var RichText = function RichText(props) {
  var children = props.children;

  var parse = function parse(string) {
    return typeof string === 'string' ? (0, _htmlReactParser.default)(string, {
      replace: function replace(domNode) {
        var node = _objectSpread({}, domNode);

        if (node.type === 'tag') {
          var _node, _node$attribs, _node2;

          if (node.name === 'a') {
            if (node.attribs.href.includes('http')) {
              node = /*#__PURE__*/_react.default.createElement("a", {
                href: node.attribs.href,
                target: "_blank"
              }, node.children.map(function (o) {
                return parse(o.data);
              }));
            } else if (node.attribs.href.includes('tel:') || node.attribs.href.includes('mailto:')) {
              node = /*#__PURE__*/_react.default.createElement("a", {
                href: node.attribs.href
              }, node.children.map(function (o) {
                return parse(o.data);
              }));
            } else {
              node = /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
                to: node.attribs.href
              }, node.children.map(function (o) {
                return parse(o.data);
              }));
            }
          } // The parser function complains when there is invalid inline CSS (missing ':').
          // That's why we need to remove it so the user can type in the code editor.


          if ((_node = node) !== null && _node !== void 0 && (_node$attribs = _node.attribs) !== null && _node$attribs !== void 0 && _node$attribs.style) {
            node.attribs.style = node.attribs.style.split(';').filter(function (s) {
              return s.includes(':');
            }).join(';');
          } // Remove all special characters from string. This is necessary when using the code editor and start adding html elements.


          if ((_node2 = node) !== null && _node2 !== void 0 && _node2.name) {
            node.name = node.name.replace(/[^a-zA-Z1-9]/g, '');
          }

          return node;
        }
      }
    }) : '';
  };

  return parse(children);
};

var _default = RichText;
exports.default = _default;